import React, { useState, useEffect } from "react";
import { Link, withPrefix } from "gatsby";
import { Link as ScrollLink } from "rc-scroll-anim";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Collapse,
  Nav as Navigation,
  Navbar,
  NavbarToggler,
  NavItem,
} from "reactstrap";

const Nav = ({ isHome, hasEquipment, hasSpecialProcess, hasMedia }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [affix, setAffix] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggle = () => {
    setIsOpen(state => !state);
  };

  const handleScroll = () => {
    // + is unary operator, same as Number(window.scrollY)
    const scrollPositionY = +window.scrollY;
    if (scrollPositionY > 300) {
      setAffix("navbar-shrink");
    } else {
      setAffix("");
    }
  };

  return (
    <Navbar id="mainNav" className={affix} light expand="lg" fixed="top">
      <div className="container">
        <>
          {isHome ? (
            <ScrollLink
              component="a"
              className="navbar-brand page-scroll"
              to="page-top"
            >
              <img
                className="logo"
                src={withPrefix("/images/logo.png")}
                alt="logo"
              />
              <span className="title">Services Shops</span>
            </ScrollLink>
          ) : (
            <Link className="navbar-brand" to="/">
              <img
                className="logo"
                src={withPrefix("/images/logo.png")}
                alt="logo"
              />
            </Link>
          )}
        </>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Navigation className="ml-auto" navbar>
            {isHome ? (
              <>
                <NavItem>
                  <ScrollLink
                    component="a"
                    className="nav-link page-scroll"
                    to="page-top"
                  >
                    <FontAwesomeIcon icon="home" />
                  </ScrollLink>
                </NavItem>
                <NavItem>
                  <ScrollLink
                    component="a"
                    className="nav-link page-scroll"
                    to="regions"
                  >
                    Our Shops
                  </ScrollLink>
                </NavItem>
              </>
            ) : (
              <>
                <NavItem>
                  <Link className="nav-link" to="/">
                    <FontAwesomeIcon icon="home" />
                  </Link>
                </NavItem>
                <NavItem>
                  <ScrollLink
                    component="a"
                    className="nav-link page-scroll"
                    to="information"
                  >
                    Key Information
                  </ScrollLink>
                </NavItem>
                {hasEquipment && (
                  <NavItem>
                    <ScrollLink
                      component="a"
                      className="nav-link page-scroll"
                      to="equipment-served"
                    >
                      Equipment Served
                    </ScrollLink>
                  </NavItem>
                )}
                {hasSpecialProcess && (
                  <NavItem>
                    <ScrollLink
                      component="a"
                      className="nav-link page-scroll"
                      to="special-processes"
                    >
                      Special Processes
                    </ScrollLink>
                  </NavItem>
                )}
                {hasMedia && (
                  <NavItem>
                    <ScrollLink
                      component="a"
                      className="nav-link page-scroll"
                      to="media"
                    >
                      Media
                    </ScrollLink>
                  </NavItem>
                )}
              </>
            )}
          </Navigation>
        </Collapse>
      </div>
    </Navbar>
  );
};

export default Nav;
